// extracted by mini-css-extract-plugin
export default {"Box":"archive-list-module__Box__UGRPLRs"};